"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BatchStatus = void 0;
const BatchStatus = exports.BatchStatus = {
  CREATED: 0,
  STARTED: 1,
  PAUSED: 2,
  FINISHED_OK: 3,
  FINISHED_NOK: 4
};